import {PredicateOf} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {
  buildInvalidQuestionOptionUids,
  buildSlugError,
  isSchedulingLinkAvailable,
  SettingsSectionsEnum,
} from '../../../../helpers/models/schedulingLinkHelpers';
import {DraftSchedulingLinkModel} from '../../../../models/api/schedulingLinkModel';

interface ValidationData {
  draftLink: DraftSchedulingLinkModel;
  otherSlugs: ReadonlyArray<string>;
}

type SchedulingLinkSettingsValidators = {[T in SettingsSectionsEnum]: PredicateOf<ValidationData>};
export const schedulingLinkSettingsValidators: SchedulingLinkSettingsValidators = {
  [SettingsSectionsEnum.AVAILABILITY]: availabilityValidator,
  [SettingsSectionsEnum.URL]: urlValidator,
  [SettingsSectionsEnum.MEETING]: meetingValidator,
  [SettingsSectionsEnum.APPEARANCE]: () => true,
};

function availabilityValidator(data: ValidationData) {
  // No availability restrictions on an existing schedulingLinks.
  if (data.draftLink.id !== undefined) {
    return true;
  }

  return isSchedulingLinkAvailable(data.draftLink);
}

function meetingValidator(data: ValidationData) {
  const invalidOptions = buildInvalidQuestionOptionUids(data.draftLink.meetingProperties.questions);
  return invalidOptions.length === 0;
}

function urlValidator(data: ValidationData) {
  return buildSlugError(data.draftLink.slug, data.otherSlugs) === null;
}
